import { StoreDetailsResponse } from "@core/models/api.response";
import {} from "@core/models/common.interface";
import { StoreDetailsDTO } from "@core/models/dto.models";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const storeActions = createActionGroup({
  source: "storedetails",
  events: {
    "Set Store Details": props<StoreDetailsDTO>(),
    "Set Store Details Success": props<StoreDetailsResponse>(),
    "Set Store Details Fail": props<StoreDetailsResponse>(),
  },
});
